/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCreditOverride.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/credit-override";

export class AutogenModelCreditOverride<RowType extends ModelRow> extends Endpoint<RowType, RowCreditOverrideFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCreditOverride extends ModelRow<RowCreditOverrideFields> {
	constructor(values?: Partial<RowCreditOverrideFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCreditOverrideFields {
	comments: string;
	company_id: string;
	customer_id: string;
	order_date: Date;
	order_id: string;
	review_date: Date;
	status: string;
	user_id: string;
}

